module.exports = __webpack_public_path__ + "img/icon_diamond.99f3eef.webp";